import { render, staticRenderFns } from "./DashboardOriginal.vue?vue&type=template&id=0206925e&"
import script from "./DashboardOriginal.vue?vue&type=script&lang=js&"
export * from "./DashboardOriginal.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports